import { Component, OnInit, Input } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';

@Component({
  selector: 'app-reviewsApiSubscriptions',
  templateUrl: './reviewsApiSubscriptions.component.html',
  styleUrls: ['./reviewsApiSubscriptions.component.css']
})
export class ReviewsApiSubscriptionsComponent implements OnInit {

  isSaving = false;
  @Input() currentProject: any;
  @Input() currentApiId: any;
  currentConfiguration: any;


  constructor(private _adminService: AdminServiceService, private _alertify: AlertifyService) { }

  ngOnInit() {
  }

  onSubscriptionAdded(event) {
    this.isSaving = true;
  
    this._adminService.addSubscription(event).subscribe(response => {
      this.currentProject.id = response["id"];
      this.currentProject.apiKey = response["apiKey"];
  
      this._alertify.success("Subscription was created.");
      this.isSaving = false;
  
    }, error => {
      this._alertify.error(error);
      this.isSaving = false;
    });
  
  }
  

}



